import { getCountry } from '../utils/locale';
import { Country } from './country';

enum SourceLocation {
    US = 1,
    CA = 2,
}

export { SourceLocation };

export function getSourceLocationForCountry(country: Country): SourceLocation {
    return country === Country.US ? SourceLocation.US : SourceLocation.CA;
}

export function getSourceLocation(): SourceLocation {
    return getSourceLocationForCountry(getCountry());
}
